import { Grid, Typography } from "@mui/material";
import { ISectionWrapper } from "../../interfaces/configuration";

const SectionWrapper = ({ title, children }: ISectionWrapper) => (
  <>
    <Grid item xs={12}>
      <Typography className="f-s-20">{title}</Typography>
    </Grid>
    {children}
  </>
);

export default SectionWrapper;
